import { useEffect, useState } from 'react';

export const useMidnightRollover = () => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const now = new Date();
    const nextMidnight = new Date(now);
    nextMidnight.setHours(24, 0, 0, 0);
    const delayMs = Math.max(0, nextMidnight.getTime() - now.getTime() + 1);

    const timeoutId = setTimeout(() => setTick((t) => t + 1), delayMs);
    return () => clearTimeout(timeoutId);
  }, [tick]);

  return tick;
};

export default useMidnightRollover;
